import { useFetch } from "../../hooks/useFetch";
import LoadSimple from "../LoadSimple";
import Modal from "react-modal";
import ModalDeleteCis from "./ModalDeleteCis";
import { useState, useEffect } from "react";
import ModalCisAfecta from "./ModalCisAfecta";
import { lang } from "../generales/traduction";
import { capitalizeFirstLetter } from "../../utils/utils";
import Action from "../Action";
const deleteCisModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    height: "30%",
    padding: "20px",
  },
};
/* estilos modal crear relacion */
const CisAfectaModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    height: "90%",
    padding: "20px",
  },
};
const CisList = ({
  pageActual,
  limitList,startLimit,
  dataList,
  devices,
  handleChangEdit,
  setData,
  setRegisterIsValid,
  setLoading,
  setError,
  server,
  dataUsers,
  setDataUsers,
  searchResults,
  setSearchResults,
  searchTerm,
  cisSelected,
  setCisSelected,
  mode,
  languaje
}) => {
  // const dataUsers=useFetch('cassia/ci','',localStorage.getItem('access_token'),'GET',server)

  const [deleteCisModalOpen, setdeleteCisModalOpen] = useState(false);
  const [userSelected, setUserSelected] = useState({});
  const [CisAfectaModalOpen, setCisAfectaModalOpen] = useState(false);
  const [cisSelectedAux, setCisSelectedAux] = useState([]);

  const displayList = dataList.filter(item => String(item.hostid) !== "10084");

  function openDeleteUserModal() {
    setdeleteCisModalOpen(true);
  }

  function closDeleteCisModal() {
    setdeleteCisModalOpen(false);
  }
  const handledeleteUserClick = (data) => {
    openDeleteUserModal();
    setUserSelected(data);
    // Realiza las acciones deseadas al hacer clic en el marcador
  };
  useEffect(() => {
    buscar_cis();
  }, []);
  const buscar_cis = () => {
    // setLoadingCis(true)
    const fetchDataPost = async () => {
      try {
        const response = await fetch(
          server.url +
            "/api/v1/cassia/provisioning_hosts/",
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        if (response.ok) {
          const data1 = await response.json();
          setDataUsers(data1);
          // setCreateCisModalOpen(true)
        } else {
          const data1 = await response.json();
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataPost();
  };
  const cisSelectRow = (elemento) => {
    setCisSelected(elemento);
  };
  function closeCisAfectaModal() {
    setCisAfectaModalOpen(false);
  }

  const openCisAfectaModal = (elemento) => {
    setCisSelectedAux(elemento);
    setCisAfectaModalOpen(true);
  };
  return (
    <>
      <div className="cont-row-user-list">
      
        {dataUsers.loading ? (
          <div className="cont-load-user-list">
            <LoadSimple></LoadSimple>
          </div>
        ) : (
          displayList
            .slice(startLimit, parseInt(pageActual) * parseInt(limitList))
            .map((elemento, indice) => (
              <div
                className={"row-table-portafolio"+mode}
                key={1}
                // onClick={() => cisSelectRow(elemento)}
              >
                <div className="field-body-table-cis field-medium">
                  {elemento.hostid}
                </div>
                <div className="field-body-table-cis field-larger" style={{width:'22%'}}>
                  {elemento.host}
                </div>
                <div className="field-body-table-cis field-larger" style={{width:'22%'}}>
                {elemento.technology_name}
                </div>
                <div className="field-body-table-cis field-larger">
                {elemento.ip}
                </div>
                <div className="field-body-table-cis field-larger">
                {elemento.operating_system_name}
                </div>
                <div className="field-body-table-cis field-larger" style={{color:(elemento.credentialsExist==0)?'red':'var(--txt-color)'}}>
                {(elemento.credentialsExist==0)?'Sin Credenciales':'Con Credenciales'}
                </div>
               
                
                <div className="field-body-table-cis field-larger">
                  
                  <div  style={{width:'100%'}}>
                  <Action
                    disabled={false}
                    origen="Azul"
                    titulo={capitalizeFirstLetter(lang[languaje]['gestionar'])}
                    action={(e) => {
                      e.stopPropagation();
                      cisSelectRow(elemento);
                    }}
                  />
                  </div>
                </div>
              </div>
            ))
        )}
        {dataUsers.loading == false && displayList.length == 0 ? (
          <div className="no-results">{capitalizeFirstLetter(lang[languaje]['sinResultados'])}</div>
        ) : (
          ""
        )}
      </div>
      <Modal
        isOpen={deleteCisModalOpen}
        // isOpen={true}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closDeleteCisModal}
        style={deleteCisModalStyles}
        contentLabel="Example Modal2"
        // shouldCloseOnOverlayClick={false}
      >
        <ModalDeleteCis
          server={server}
          setRegisterIsValid={setRegisterIsValid}
          setData={setData}
          setLoading={setLoading}
          setError={setError}
          cis={userSelected}
          closDeleteCisModal={closDeleteCisModal}
        ></ModalDeleteCis>
      </Modal>
      {/* modal cis que afecta */}
      <Modal
        isOpen={CisAfectaModalOpen}
        // isOpen={false}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closeCisAfectaModal}
        style={CisAfectaModalStyles}
        contentLabel="Example Modal2"
        // shouldCloseOnOverlayClick={false}
      >
        <ModalCisAfecta
          server={server}
          cisSelected={cisSelectedAux}
          closeCisAfectaModal={closeCisAfectaModal}
          languaje={languaje}
          mode={mode}
        ></ModalCisAfecta>
      </Modal>
    </>
  );
};

export default CisList;
